import { render } from "./LaboratoryDetail.vue?vue&type=template&id=5cbecc30&scoped=true"
import script from "./LaboratoryDetail.vue?vue&type=script&lang=js"
export * from "./LaboratoryDetail.vue?vue&type=script&lang=js"

import "./LaboratoryDetail.vue?vue&type=style&index=0&id=5cbecc30&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/prodbqwjw/sy-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbecc30"]])

export default __exports__